(function($){

	$(document).ready(function () {
        $(".set > .click-link").on("click", function () {
            if ($(this).hasClass("active-tab")) {
                $(this).removeClass("active-tab");
                $(this).siblings(".content").slideUp(200);
                $(".set > .click-link span").removeClass("fa_minus").addClass("fa_plus");
            } else {
                $(".set > .click-link span").removeClass("fa_minus").addClass("fa_plus");
                $(this).find("span").removeClass("fa_plus").addClass("fa_minus");
                $(".set > .click-link").removeClass("active-tab");
                $(this).addClass("active-tab");
                $(".content").slideUp(200);
                $(this).siblings(".content").slideDown(200);
            }
          
            var pane = $(this);
            setTimeout(function(){
              var $panel = pane.closest('.set > .click-link');
              $('html,body').animate({
                scrollTop: $panel.offset().top - 150
              }, 500); 
            }, 300 );
          
        });
    });

})(jQuery);